import { getBasicStaticPropsWrapper } from '@bridebook/web/app-basic/lib/get-basic-static-props-wrapper';
import ErrorPage from '@bridebook/web/pages/_error';

export const getStaticProps = getBasicStaticPropsWrapper([], async () => ({
  props: { statusCode: 404 },
}));

export default ErrorPage;
